/* eslint-disable */
import filtersAddAddress from './Actions/FiltersAddAddress.action';
import filtersNextDateRangeSelected from './Actions/FiltersNextDateRangeSelected.action';
import filtersNumberOfDaysSelected from './Actions/FiltersNumberOfDaysSelected.action';
import filtersPrevDateRangeSelected from './Actions/FiltersPrevDateRangeSelected.action';
import filtersRemoveAddress from './Actions/FiltersRemoveAddress.action';
import filtersRemoveAllAddresses from './Actions/FiltersRemoveAllAddresses.action';
import filtersSelectAccount from './Actions/FiltersSelectAccount.action';
import filtersSelectAddress from './Actions/FiltersSelectAddress.action';
import filtersSelectProject from './Actions/FiltersSelectProject.action';
import filtersStartDateSelected from './Actions/FiltersStartDateSelected.action';
import filtersStatusSelected from './Actions/FiltersStatusSelected.action';
import filtersTodayDateSelected from './Actions/FiltersTodayDateSelected.action';
import filtersToggleAllAddresses from './Actions/FiltersToggleAllAddresses.action';
import filtersUnselectAddress from './Actions/FiltersUnselectAddress.action';

const filtersActionCreators = {
  filtersAddAddress,
  filtersNextDateRangeSelected,
  filtersNumberOfDaysSelected,
  filtersPrevDateRangeSelected,
  filtersRemoveAddress,
  filtersRemoveAllAddresses,
  filtersSelectAccount,
  filtersSelectAddress,
  filtersStartDateSelected,
  filtersStatusSelected,
  filtersTodayDateSelected,
  filtersSelectProject,
  filtersToggleAllAddresses,
  filtersUnselectAddress,
};

export default filtersActionCreators;
